import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { CTA, CustomInput, CustomSelect, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import {
  getValues,
  isValidForm,
  newForm,
  newFormField,
} from '../../../../utils/form';
import { RegexpType, validator } from '../../../../utils/validator';
import { FileImg, InputRow, Separator } from './style';
import InputLegend from '../../InputLegend';
import theme from '../../../theme';
import CustomTextarea from '../../CustomTextarea';
import CustomToggle from '../../CustomToggle';
import {
  DOCUMENTS_EXPERT_CATEGORIES_GET,
  DOCUMENTS_EXPERT_DOCUMENT_CREATE,
} from '../../../../app/redux/actions/documentsExpert';
import { formatFilterOpt } from '../../../../utils/labels';
import { withFileUploader } from '../../../../app/hoc/withFileUploader';
import { apiHost, baseUrl } from '../../../../app/api/config';
import { flattenCategories } from '../../../../utils/categories';
import DropZone from '../../DropZone';
import {
  acceptedDocsTypes,
  getFileExtension,
  getIconByExtension,
} from '../../../../utils/fileExtension';
import { DropZoneWrapper } from '../../DropZone/style';

// const acceptedFiles = ['.jpg', '.jpeg', '.png'];

const initialForm = newForm([
  newFormField({
    field: 'title',
    required: true,
    type: RegexpType.STRING,
    valid: true,
    value: undefined,
  }),
  newFormField({
    field: 'category_ids',
    required: true,
    type: RegexpType.STRING,
    valid: true,
    value: undefined,
  }),
  newFormField({
    field: 'typology_ids',
    required: true,
    type: RegexpType.STRING,
    valid: true,
    value: undefined,
  }),
  newFormField({
    field: 'description',
    required: true,
    type: RegexpType.STRING,
    valid: true,
    value: undefined,
  }),
]);

export const ModalCreateDocumentId = 'ModalCreateDocument';

const ModalCreateDocument = ({
  mediaIsPhone,
  isOpen,
  id,
  payload,
  filters,
  categoriesAll,
  newDocumentId,
  getCategoriesAll,
  modalClose,
  createDocument,
  onFileChange,
  isSupervisor,
}) => {
  const scrollableAreaRef = useRef(null);
  // const coverRef = useRef(null);
  const docRef = useRef(null);
  const [form, setForm] = useState({ ...initialForm });
  const [publishDocument, setPublishDocument] = useState(true);
  // const [cover, setCover] = useState();
  // document
  const [validFormat, setValidFormat] = useState(true);
  const [document, setDocument] = useState();
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (!categoriesAll?.length > 0) getCategoriesAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnChange = (field = '', newValue) => {
    const { type } = form[field];
    setForm({
      ...form,
      [field]: {
        ...form[field],
        value: newValue,
        valid:
          typeof newValue === 'object' ? true : validator(type, newValue, true),
      },
    });
  };

  const checkSupportedFiles = (files = []) => {
    let isSupported = true;

    //? use this to debug MIME type needed for the dropped file
    //console.log("🚀 ~ files[0].type:", files[0].type);

    if (files?.length > 1) {
      isSupported = false;
      setValidFormat(false);
    } else {
      isSupported =
        acceptedDocsTypes.findIndex((t) => t === files[0].type) >= 0;
    }
    if (!isSupported) {
      setValidFormat(false);
    } else {
      setDocument(files[0]);
      setValidFormat(true);
    }
  };
  const handleFileDrop = (monitor) => {
    if (monitor) {
      const { files } = monitor.getItem();
      checkSupportedFiles(files);
    }
  };

  const handleCreateDocument = () => {
    const body = getValues(form);
    body.published = publishDocument;
    createDocument(body);
  };

  // useEffect(() => {
  //   if (newDocumentId) {
  //     // upload cover
  //     onFileChange({
  //       file: cover,
  //       key: 'cover',
  //       url: `${apiHost}${baseUrl}pzzl_document/documents_for_experts/${newDocumentId}/cover/upload`,
  //       callback: () => setCover(),
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [newDocumentId]);

  useEffect(() => {
    if (newDocumentId && document) {
      // upload doc
      onFileChange({
        file: document,
        key: 'document',
        url: `${apiHost}${baseUrl}pzzl_document/documents_for_experts/${newDocumentId}/document/upload`,
        callback: () => {
          setDocument();
          if (typeof payload?.callback === 'function') payload?.callback();
          setUploading(false);
          if (scrollableAreaRef) scrollableAreaRef.current.scrollTop = 0;
          modalClose();
          setForm({ ...initialForm });
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newDocumentId]);

  return (
    <Modal
      title="Crea documento"
      modalId={ModalCreateDocumentId}
      scrollableAreaRef={scrollableAreaRef}
      description="Inserisci di seguito tutti i valori per creare il documento"
      forceOpen={uploading}
      className="max-size"
    >
      <ScrollableArea ref={scrollableAreaRef}>
        <InputRow>
          <div>
            <InputLegend label="Titolo" required htmlFor="document-title" />
            <CustomInput
              size={mediaIsPhone ? 'full' : 'm'}
              placeholder="Titolo"
              value={form.title.value}
              onChange={(v) => handleOnChange('title', v)}
              id="document-title"
            />
          </div>
          {isSupervisor && (
            <div>
              <InputLegend label="Visibilità" htmlFor="document-visibility" />
              <CustomToggle
                checked={publishDocument}
                onClick={() => setPublishDocument(!publishDocument)}
                id="document-visibility"
              />
            </div>
          )}
          {/* <div>
            <InputLegend label="Copertina del documento" required />
            <div className="d-flex">
              <CTA
                btnText="Seleziona"
                onClick={() => coverRef.current.click()}
              />
              <input
                type="file"
                className="d-none"
                accept={acceptedFiles.join(',')}
                ref={coverRef}
                onChange={(e) => setCover(e.target.files[0])}
              />
              <Text type="b4">
                {cover ? cover?.name : "Nessun'immagine selezionata"}
              </Text>
              {cover && (
                <CTA
                  type="tertiary"
                  btnText="Elimina"
                  icon="trash-01"
                  onClick={() => setCover()}
                />
              )}
            </div>
          </div> */}
        </InputRow>
        <Separator />
        <InputRow>
          <div>
            <InputLegend label="Risorse" required htmlFor="document-category" />
            <CustomSelect
              size={mediaIsPhone ? 'full' : 'm'}
              id="document-category"
              value={form.category_ids.value}
              options={flattenCategories(categoriesAll, 0, true)}
              onChange={({ value }) =>
                handleOnChange('category_ids', [`${value}`])
              }
              menuPlacement="bottom"
              key={`${newDocumentId}-category-select`}
              //^ trick to reset select after document creation
            />
          </div>
          <div>
            <InputLegend
              label="Tipologia"
              required
              htmlFor="document-typology"
            />
            <CustomSelect
              size={mediaIsPhone ? 'full' : 'm'}
              id="document-typology"
              value={form.typology_ids.value}
              options={(filters?.typology || []).map((opt) =>
                formatFilterOpt(opt)
              )}
              onChange={({ value }) =>
                handleOnChange('typology_ids', [`${value}`])
              }
              menuPlacement="bottom"
              key={`${newDocumentId}-typology-select`}
              //^ trick to reset select after document creation
            />
          </div>
        </InputRow>
        <Separator />
        <div>
          <InputLegend
            label="Descrizione"
            required
            htmlFor="document-description"
          />
          <CustomTextarea
            placeholder="Descrizione"
            id="document-description"
            value={form.description.value}
            onChange={(value) => handleOnChange('description', value)}
            minHeight={100}
            mb={48}
          />
        </div>
        <div>
          <InputLegend label="Inserisci un documento" required />
          {document ? (
            <DropZoneWrapper className="d-flex">
              <FileImg
                src={getIconByExtension(getFileExtension(document?.name))}
                alt={
                  `${getFileExtension(document?.name)} file extension icon` ??
                  ''
                }
              />
              <Text type="b4"> {document?.name}</Text>
              <CTA
                type="tertiary"
                btnText="Elimina"
                icon="trash-01"
                onClick={() => setDocument()}
              />
            </DropZoneWrapper>
          ) : mediaIsPhone ? (
            <div className="d-flex flex-col align-start mb-5">
              <Text type="b4" mb={8}>
                Effettua la selezione da:
              </Text>
              <CTA
                btnText="Questo dispositivo"
                fullsize
                onClick={() => docRef.current.click()}
              />
              <input
                ref={docRef}
                className="d-none"
                type="file"
                id="inputFile"
                onChange={(e) => setDocument(e.target.files[0])}
                accept={acceptedDocsTypes.join(',')}
              />
            </div>
          ) : (
            <DndProvider backend={HTML5Backend}>
              <DropZone
                onDrop={handleFileDrop}
                onClick={() => docRef.current.click()}
                validFormat={validFormat}
                onlyFromPC
              />
              <input
                ref={docRef}
                className="d-none"
                type="file"
                id="inputFile"
                onChange={(e) => setDocument(e.target.files[0])}
                accept={acceptedDocsTypes.join(',')}
              />
            </DndProvider>
          )}
        </div>
        <Text type="b3" mb={48} color={theme().colors.fail}>
          * campo obbligatorio
        </Text>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
          disabled={uploading}
        />
        <CTA
          type="primary"
          btnText="conferma"
          fullsize={mediaIsPhone}
          disabled={!isValidForm(form) || !document || uploading}
          onClick={() => {
            setUploading(true);
            handleCreateDocument();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalCreateDocument.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  payload: PropTypes.object,
  isOpen: PropTypes.bool,
  id: PropTypes.string,
  categoriesAll: PropTypes.array,
  filters: PropTypes.object,
  newDocumentId: PropTypes.number,
  isSupervisor: PropTypes.bool,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getCategoriesAll: PropTypes.func.isRequired,
  createDocument: PropTypes.func.isRequired,
  // HOC: withFileUploader
  onFileChange: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { payload, isOpen, id } = state.app.modal;
      const { categoriesAll, filters, newDocumentId } = state.documentsExpert;
      const { isSupervisor } = state.user;
      return {
        payload,
        isOpen,
        id,
        categoriesAll,
        filters,
        newDocumentId,
        isSupervisor,
      };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getCategoriesAll: () =>
        dispatch({
          type: DOCUMENTS_EXPERT_CATEGORIES_GET._REQUEST,
          show_all: true,
        }),
      createDocument: (payload) =>
        dispatch({ type: DOCUMENTS_EXPERT_DOCUMENT_CREATE._REQUEST, payload }),
    })
  ),
  withFileUploader
)(withMediaQueries(ModalCreateDocument));
